module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/u77Vnp/tc-custom/9781418580711.jpg?1708485784626",
      "alt": "This image is the cover for the book Finding Purpose Beyond Our Pain"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Finding Purpose Beyond Our Pain\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("A revolutionary approach to dealing with life's challenges that guides readers in how to face them and to recognize them as gifts from God.")])]), _c('p', [_vm._v("At one time or another everyone finds themselves questioning, \"Does God still love me? Is there a purpose for all this pain?\" Drs. Meier and Henderson teach readers how to face painful struggles head-on in a way that allows them to grow and mature emotionally and spiritually. In this timely book they explore the seven most common life challenges:")]), _vm._v("InjusticeRejectionLonelinessLossDisciplineFailureDeath"), _c('p', [_vm._v("In addition they offer the three reasons we often miss the gifts these challenges can be. This unique approach to an age-old problem will encourage and challenge readers to grow through their struggles instead of wasting energy trying to avoid them altogether.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Paul Meier, David L. Henderson\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Thomas Nelson\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0